var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRightarrow2 = function SvgRightarrow2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-6691.669 -5818.307 14.879 11.31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12943",
    transform: "translate(-7243 -6022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12942"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7797",
    width: 8,
    height: 1.55,
    rx: 0.775,
    transform: "translate(551.331 209.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7798",
    width: 8,
    height: 1.55,
    rx: 0.775,
    transform: "translate(556.987 215.003) rotate(-135)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7799",
    width: 14,
    height: 1.55,
    rx: 0.775,
    transform: "translate(552.21 208.56)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightarrow2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rightarrow2.e2f7094d.svg";
export { ForwardRef as ReactComponent };